
import React from 'react';
import ConditionPageTemplate from './ConditionPageTemplate';

const DullDehydratedSkin = () => {
  const treatments = [
    {
      name: "AquaFirme Facial",
      href: "/treatments/aquafirme",
      description: "Deep hydration and exfoliation for instant radiance",
      price: "$199",
      memberPrice: "$149"
    },
    {
      name: "IV Drips (Glow Boost)",
      href: "/treatments/iv-therapy",
      description: "Hydration and vitamins delivered directly to bloodstream",
      price: "$199",
      memberPrice: "$149"
    },
    {
      name: "Skin Boosters",
      href: "/treatments/skin-boosters",
      description: "Injectable hydration for long-lasting glow",
      price: "$399",
      memberPrice: "$299"
    }
  ];

  return (
    <ConditionPageTemplate
      title="Dull or Dehydrated Skin"
      subtitle="You're Not Tired — Your Skin Is"
      description="We address fatigue, dehydration, and lack of glow with hydrating facials, skin boosters, and IV therapy. Perfect for tired-looking skin, dehydration, and lack of radiance."
      treatments={treatments}
      beforeAfterText="Instant radiance in 45 minutes or less. Members get free birthday facials!"
    />
  );
};

export default DullDehydratedSkin;
